module.exports = __webpack_public_path__ + "static/media/user.299ffe43.png";